// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SendFolderPopup_head{
    display: flex;
    justify-content: space-between;
}

.SendFolderPopup_buttons{
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    align-items: flex-end;
}

.SendFolderPopup_scroll{
    height: 100%;
    overflow: hidden;
}

.SendFolderPopup_scroll_content{
    padding-right: 16px;
    padding-bottom: 12px;
    display: flex;
    flex-direction: column;
}

.SendFolderPopup_shadow{
    z-index: 1;
}

.SendFolderPopup_shadow .StyledPopupWrapper {
    width: 520px;
    max-width: 90vw;
    height: 600px;
    max-height: 85vh;
}

.SendFolderPopup_preview{
    padding-top: 20px;
}

.SendFolderPopup{
    .GoodScroll_gradient_top{
        background-image: linear-gradient(180deg, #fff 0%, #fff0 100%);
    }

    .GoodScroll_gradient_bottom{
        background-image: linear-gradient(0deg, #fff 0%, #fff0 100%);
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/meetingPage/components/sendFolderPopup/SendFolderPopup.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,8DAA8D;IAClE;;IAEA;QACI,4DAA4D;IAChE;AACJ","sourcesContent":[".SendFolderPopup_head{\n    display: flex;\n    justify-content: space-between;\n}\n\n.SendFolderPopup_buttons{\n    display: flex;\n    gap: 10px;\n    justify-content: flex-end;\n    align-items: flex-end;\n}\n\n.SendFolderPopup_scroll{\n    height: 100%;\n    overflow: hidden;\n}\n\n.SendFolderPopup_scroll_content{\n    padding-right: 16px;\n    padding-bottom: 12px;\n    display: flex;\n    flex-direction: column;\n}\n\n.SendFolderPopup_shadow{\n    z-index: 1;\n}\n\n.SendFolderPopup_shadow .StyledPopupWrapper {\n    width: 520px;\n    max-width: 90vw;\n    height: 600px;\n    max-height: 85vh;\n}\n\n.SendFolderPopup_preview{\n    padding-top: 20px;\n}\n\n.SendFolderPopup{\n    .GoodScroll_gradient_top{\n        background-image: linear-gradient(180deg, #fff 0%, #fff0 100%);\n    }\n\n    .GoodScroll_gradient_bottom{\n        background-image: linear-gradient(0deg, #fff 0%, #fff0 100%);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
